import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";
import { MyButton } from "../../components/button/styles";

export const CompletedProjectsWrapper = styled.div`
    text-align: center;
    margin: 5rem ${'-' + globalStyles.desktop.pageMargin};
    padding: 5rem ${globalStyles.desktop.pageMargin} 10rem ${globalStyles.desktop.pageMargin};
    background-color: #f9fafb;
`

export const CardsWrapper = styled.div`
    margin-top: 4rem;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-row-gap: 2rem;
    grid-column-gap: 2rem;

    @media only screen and (max-width: ${globalStyles.breakpoints.large}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        grid-template-columns: minmax(0, 1fr);
    }
`

export const Card = styled.div`
    text-align: left;
    font-size: 0.9rem;
    padding: 1rem;
    border: 1px solid #dbeafe;
    
    p {
        margin-block-end: 0.5rem;
        margin-block-start: 0.5rem;
    }
`

export const Image = styled.img`
    display: block;
    width: 100%;
`

export const ViewMoreButton = styled(MyButton)`
    float: right;
    margin-top: 2rem;
`